/* One recommendation selection for the current cart. Section refreshes reuse it. */
if (!customElements.get('cart-recommendations-component')) {
  let selection = null;

  function selectRecommendations(element) {
    // The cart section already renders three curated, available complements.
    // Keep this first selection during later cart updates instead of requesting a new set.
    const html = element.querySelector('.promis-cart-recommendations')?.outerHTML || '';
    selection = { html };
    return selection;
  }

  customElements.define('cart-recommendations-component', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', event => {
        const arrow = event.target.closest('[data-recommendation-direction]');
        const track = this.querySelector('.promis-cart-recommendations__list');
        if (!arrow || !track) return;
        const card = track.querySelector('.promis-cart-suggestion');
        const step = (card?.getBoundingClientRect().width || track.clientWidth) + 12;
        track.scrollBy({ left: Number(arrow.dataset.recommendationDirection) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    }

    connectedCallback() {
      // Native cart section rendering replaces this element after cart changes.
      // Reuse the original selection and the existing native product-form handlers.
      if (Number(this.dataset.cartCount) === 0) {
        selection = null;
        this.hidden = true;
        return;
      }
      const current = selection || selectRecommendations(this);
      this.renderSelection(current.html);
    }

    renderSelection(markup) {
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const recommended = parsed.querySelector('.promis-cart-recommendations');
      const inCart = new Set((this.dataset.cartProductIds || '').split(','));
      recommended?.querySelectorAll('.promis-cart-suggestion').forEach(card => {
        if (inCart.has(card.dataset.productId)) card.remove();
      });
      this.replaceChildren(...(recommended ? [recommended] : []));
      this.hidden = !this.querySelector('.promis-cart-suggestion');
    }
  });
}

if (!customElements.get("add-to-cart-button")) {
  class AddToCartComponent extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = document.querySelector("cart-drawer");
      this.Notification = window.FoxTheme?.Notification;
      this.addToCartButton = this.querySelector(
        ".f-cart-recommendations__item-add-to-cart"
      );
      this.addEventListener("click", this.onSubmitHandler.bind(this));
    }

    onSubmitHandler() {
      this.addToCartButton.classList.add("btn--loading");
      const variantId = this.dataset.variantId;

      if (!variantId) return;

      const config = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      if (this.cartDrawer) {
        formData.append(
          "sections",
          this.cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
      }

      config.body = formData;

      fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return this.Notification.show({
              target: document.body,
              method: "appendChild",
              type: "warning",
              message: response.description,
              last: 3000,
              sticky: true,
            });
          }
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.addToCartButton.classList.remove("btn--loading");
        });
    }
  }
  customElements.define("add-to-cart-button", AddToCartComponent);
}
